<td class="value-cell">{{index}}</td>
<td class="value-cell" title="{{combinedReplaceIdStatistic.id}}">{{combinedReplaceIdStatistic.id}}
</td>
<td class="value-cell" title="{{combinedReplaceIdStatistic.oldId}}">
    {{combinedReplaceIdStatistic.oldId}}</td>
<td class="value-cell" title="{{combinedReplaceIdStatistic.newId}}">
    {{combinedReplaceIdStatistic.newId}}</td>
<td class="value-cell" ngClass="{{combinedReplaceIdStatistic.updatedZCRecordsError?'red-text':''}}"
    title="{{combinedReplaceIdStatistic.oldIdZCCount}} ({{combinedReplaceIdStatistic.updatedZCRecordsCount}}) {{combinedReplaceIdStatistic.newIdZCCount}}">
    {{combinedReplaceIdStatistic.oldIdZCCount}} ({{combinedReplaceIdStatistic.updatedZCRecordsCount}})
    {{combinedReplaceIdStatistic.newIdZCCount}}
</td>
<td class="value-cell" ngClass="{{combinedReplaceIdStatistic.updatedZCVRecordsError?'red-text':''}}"
    title="{{combinedReplaceIdStatistic.oldIdZCVCount}} ({{combinedReplaceIdStatistic.updatedZCVRecordsCount}}) {{combinedReplaceIdStatistic.newIdZCVCount}}">
    {{combinedReplaceIdStatistic.oldIdZCVCount}} ({{combinedReplaceIdStatistic.updatedZCVRecordsCount}})
    {{combinedReplaceIdStatistic.newIdZCVCount}}
</td>
<td class="value-cell" ngClass="{{combinedReplaceIdStatistic.updatedPRsPlaceError?'red-text':''}}"
    title="{{combinedReplaceIdStatistic.oldIdPRsPlaceCount}} ({{combinedReplaceIdStatistic.updatedPRsPlaceCount}}) {{combinedReplaceIdStatistic.newIdPRsPlaceCount}}">
    {{combinedReplaceIdStatistic.oldIdPRsPlaceCount}} ({{combinedReplaceIdStatistic.updatedPRsPlaceCount}})
    {{combinedReplaceIdStatistic.newIdPRsPlaceCount}}
</td>
<td class="value-cell" ngClass="{{combinedReplaceIdStatistic.updatedPRsLandUseError?'red-text':''}}"
    title="{{combinedReplaceIdStatistic.oldIdPRsLandUseCount}} ({{combinedReplaceIdStatistic.updatedPRsLandUseCount}}) {{combinedReplaceIdStatistic.newIdPRsLandUseCount}}">
    {{combinedReplaceIdStatistic.oldIdPRsLandUseCount}} ({{combinedReplaceIdStatistic.updatedPRsLandUseCount}})
    {{combinedReplaceIdStatistic.newIdPRsLandUseCount}}
</td>
<td class="value-cell" ngClass="{{combinedReplaceIdStatistic.updatedPRsZoningCodeIdError?'red-text':''}}"
    title="{{combinedReplaceIdStatistic.oldIdPRsZoningCodeIdCount}} ({{combinedReplaceIdStatistic.updatedPRsZoningCodeIdCount}}) {{combinedReplaceIdStatistic.newIdPRsZoningCodeIdCount}}">
    {{combinedReplaceIdStatistic.oldIdPRsZoningCodeIdCount}}
    ({{combinedReplaceIdStatistic.updatedPRsZoningCodeIdCount}})
    {{combinedReplaceIdStatistic.newIdPRsZoningCodeIdCount}}
</td>